import {
  PASSWORD_UPPERCASE_REGEX,
  PASSWORD_NUMBER_REGEX,
  PASSWORD_LOWERCASE_REGEX,
  PASSWORD_NO_WHITESPACE_REGEX,
  PASSWORD_SPECIAL_CHAR_REGEX,
  PASSWORD_ESCAPED_SPECIALS,
} from "@evennt-tech/api-v2-core";

export const MIN_PASSWORD_LENGTH = 8;

export const PASSWORD_VALIDATION_REGEX_MAP = {
  HasUpper: PASSWORD_UPPERCASE_REGEX,
  HasLower: PASSWORD_LOWERCASE_REGEX,
  HasNumber: PASSWORD_NUMBER_REGEX,
  HasSpecial: PASSWORD_SPECIAL_CHAR_REGEX,
  NoWhitespace: PASSWORD_NO_WHITESPACE_REGEX,
} as const;

export const PASSWORD_VALIDATION_REGEX = Object.values(
  PASSWORD_VALIDATION_REGEX_MAP
);

export enum PasswordValidationRule {
  MinLen = "minLength",
  UpperCase = "upperCase",
  LowerCase = "lowerCase",
  SpecialChar = "special",
  Digit = "digit",
}

export const PASSWORD_VALIDATION_RULES = Object.values(PasswordValidationRule);
export const PASSWORD_UNSUPPORTED_CHARS_REGEX = new RegExp(
  `[^A-Za-z0-9${PASSWORD_ESCAPED_SPECIALS}]`
);

export const PASSWORD_VALIDATION_RULE_MESSAGE: Record<
  PasswordValidationRule,
  string
> = {
  [PasswordValidationRule.UpperCase]: "Contains Uppercase",
  [PasswordValidationRule.LowerCase]: "Contains Lowercase",
  [PasswordValidationRule.MinLen]: "At least 8 characters",
  [PasswordValidationRule.SpecialChar]: "Contains Symbols",
  [PasswordValidationRule.Digit]: "Contains Number",
};

export const PASSWORD_VALIDATION_RULE_TRANSLATION_KEY: Record<
  PasswordValidationRule,
  string
> = {
  [PasswordValidationRule.UpperCase]: "common.password_rules.upper_case",
  [PasswordValidationRule.LowerCase]: "common.password_rules.lower_case",
  [PasswordValidationRule.MinLen]: "common.password_rules.min_length",
  [PasswordValidationRule.SpecialChar]: "common.password_rules.special_char",
  [PasswordValidationRule.Digit]: "common.password_rules.digit",
};

export const PASSWORD_UNSUPPORTED_CHARACTERS_ERROR =
  "PASSWORD_UNSUPPORTED_CHARACTERS_ERROR";
